module.exports = __webpack_public_path__ + "img/back.19865cf3.svg";